"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _rcTabs = _interopRequireDefault(require("@foxui/rc-tabs"));
var _CloseOutlined = _interopRequireDefault(require("@foxui/ui-icons/CloseOutlined"));
var _EllipsisOutlined = _interopRequireDefault(require("@foxui/ui-icons/EllipsisOutlined"));
var _PlusOutlined = _interopRequireDefault(require("@foxui/ui-icons/PlusOutlined"));
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../button"));
var _configProvider = _interopRequireWildcard(require("../config-provider"));
var _SizeContext = _interopRequireDefault(require("../config-provider/SizeContext"));
var _warning = _interopRequireDefault(require("../_util/warning"));
var _useAnimateConfig = _interopRequireDefault(require("./hooks/useAnimateConfig"));
var _useLegacyItems = _interopRequireDefault(require("./hooks/useLegacyItems"));
var _TabPane = _interopRequireDefault(require("./TabPane"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

// import type { EditableConfig } from '@foxui/rc-tabs/lib/interface';

function Tabs(_a) {
  var type = _a.type,
    className = _a.className,
    propSize = _a.size,
    _onEdit = _a.onEdit,
    hideAdd = _a.hideAdd,
    centered = _a.centered,
    addIcon = _a.addIcon,
    children = _a.children,
    items = _a.items,
    animated = _a.animated,
    _a$fullContent = _a.fullContent,
    fullContent = _a$fullContent === void 0 ? true : _a$fullContent,
    _a$private__scrollCon = _a.private__scrollContent,
    private__scrollContent = _a$private__scrollCon === void 0 ? fullContent : _a$private__scrollCon,
    _a$private__InjectPop = _a.private__InjectPopupContainer,
    private__InjectPopupContainer = _a$private__InjectPop === void 0 ? false : _a$private__InjectPop,
    borderPane = _a.borderPane,
    editable = _a.editable,
    props = __rest(_a, ["type", "className", "size", "onEdit", "hideAdd", "centered", "addIcon", "children", "items", "animated", "fullContent", "private__scrollContent", "private__InjectPopupContainer", "borderPane", "editable"]);
  var customizePrefixCls = props.prefixCls,
    _props$moreIcon = props.moreIcon,
    moreIcon = _props$moreIcon === void 0 ? /*#__PURE__*/React.createElement(_EllipsisOutlined["default"], null) : _props$moreIcon;
  var _React$useContext = React.useContext(_configProvider.ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    direction = _React$useContext.direction,
    getPopupContainer = _React$useContext.getPopupContainer;
  var prefixCls = getPrefixCls('tabs', customizePrefixCls);
  // let editable: EditableConfig | undefined;
  if (type === 'editable-card' && editable === undefined) {
    editable = {
      onEdit: function onEdit(editType, _ref) {
        var key = _ref.key,
          event = _ref.event;
        _onEdit === null || _onEdit === void 0 ? void 0 : _onEdit(editType === 'add' ? event : key, editType);
      },
      removeIcon: /*#__PURE__*/React.createElement(_button["default"], {
        type: "text",
        icon: /*#__PURE__*/React.createElement(_CloseOutlined["default"], null),
        size: "small"
      }),
      addIcon: addIcon || /*#__PURE__*/React.createElement(_PlusOutlined["default"], null),
      showAdd: hideAdd !== true
    };
  }
  var rootPrefixCls = getPrefixCls();
  process.env.NODE_ENV !== "production" ? (0, _warning["default"])(!('onPrevClick' in props) && !('onNextClick' in props), 'Tabs', '`onPrevClick` and `onNextClick` has been removed. Please use `onTabScroll` instead.') : void 0;
  var mergedItems = (0, _useLegacyItems["default"])(items, children);
  var mergedAnimated = (0, _useAnimateConfig["default"])(prefixCls, animated);
  var TabsRef = React.useRef(null);
  var scrollable = fullContent && private__scrollContent;
  // const injectScrollableContainer = private__InjectPopupContainer; // todo 之后未来解决 popupContainer 的时候再打开
  var injectScrollableContainer = false;
  var tabContainer = /*#__PURE__*/React.createElement(_SizeContext["default"].Consumer, null, function (contextSize) {
    var _classNames;
    var size = propSize !== undefined ? propSize : contextSize;
    return /*#__PURE__*/React.createElement(_rcTabs["default"], (0, _extends2["default"])({
      ref: TabsRef,
      direction: direction,
      getPopupContainer: getPopupContainer,
      moreTransitionName: "".concat(rootPrefixCls, "-slide-up")
    }, props, {
      items: mergedItems,
      className: (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(size), size), "".concat(prefixCls, "-button"), type === 'button' && props.tabPosition !== 'left' && props.tabPosition !== 'right'), "".concat(prefixCls, "-text"), type === 'text' && props.tabPosition !== 'left' && props.tabPosition !== 'right'), "".concat(prefixCls, "-card"), ['card', 'editable-card'].includes(type)), "".concat(prefixCls, "-editable-card"), type === 'editable-card'), "".concat(prefixCls, "-centered"), centered), "".concat(prefixCls, "-full-content"), fullContent), "".concat(prefixCls, "-full-content--scrollable"), scrollable), "".concat(prefixCls, "-full-content--popupContainer"), injectScrollableContainer), "".concat(prefixCls, "-border-pane"), borderPane !== null && borderPane !== void 0 ? borderPane : false), (0, _defineProperty2["default"])((0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-soft-primary-button"), type === 'soft-primary-button'), "".concat(prefixCls, "-soft-secondary-button"), type === 'soft-secondary-button')), className),
      editable: editable,
      moreIcon: moreIcon,
      prefixCls: prefixCls,
      animated: mergedAnimated
    }));
  });
  var getPopupContainerInjectPopupContainer = React.useCallback(function (triggerNode) {
    var _a, _b, _c, _d, _e;
    if (triggerNode) {
      // 深度优先先序遍历
      var scrollPanel = Array.prototype.find.call((_c = (_b = (_a = TabsRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(".".concat(prefixCls, "-content"))) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : [], function (el) {
        return el.className.includes("".concat(prefixCls, "-tabpane-active"));
      });
      return (_d = scrollPanel !== null && scrollPanel !== void 0 ? scrollPanel : getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer(triggerNode)) !== null && _d !== void 0 ? _d : document.body;
    }
    // 由于 Modal 的用法不存在 triggerNode，这样会导致 triggerNode is undefined 的报错
    return (_e = getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer(triggerNode)) !== null && _e !== void 0 ? _e : document.body;
  }, [getPopupContainer, prefixCls]);
  if (injectScrollableContainer) {
    return /*#__PURE__*/React.createElement(_configProvider["default"], {
      getPopupContainer: getPopupContainerInjectPopupContainer
    }, tabContainer);
  }
  return tabContainer;
}
Tabs.TabPane = _TabPane["default"];
var _default = exports["default"] = Tabs;